import axios from 'axios';

export const loadTutorialState = async ({ __config, tutorialName }) => {
	const item = tutorialName === 'patientChart' ? 'patientChartTutorial' : 'imageViewer3DTutorial';
	const response = await axios.get(`${__config.data_sources.fhir}/config?item=${item}`);

	if (response.status !== 200) return;

	let result;

	try {
		result = JSON.parse(response.data.value || '{}');
	} catch (error) {
		console.error(error);
	}

	return result?.config;
};

export const saveTutorialState = async ({ __config, tutorialState, tutorialName }) => {
	const item = tutorialName === 'patientChart' ? 'patientChartTutorial' : 'imageViewer3DTutorial';
	console.log('Saving tutorial state:', tutorialState, item);
	await axios.post(`${__config.data_sources.fhir}/config`, {
		item,
		valueType: 1,
		value: JSON.stringify({
			config: tutorialState,
		}),
	});
};
